let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2J0po")).then(() => parcelRequire('hn7zF'));